import { observable, runInAction } from 'mobx';
import { CategoryModel } from 'services/listCategory_services';
import { IProductRoutingServices, ProductRoutingModel } from './../services/productRouting_services';
import { ListStatusProduct } from 'services/commonDate_services';

export type ProductRoutingStore = {
  productRouting: {
    data: ProductRoutingModel[];
    message: string;
    isSuccess: boolean;
    recordsTotal: number;
    resultsCount: number;
    pagesCount: number;
  };
  importExcelResponse: {
    message: string;
    isSuccess: boolean;
  };
  listProductCodeResponse: {
    data: Array<CategoryModel>;
    message: string;
    isSuccess: boolean;
  };

  listMold: {
    data: Array<CategoryModel>;
    message: string;
    isSuccess: boolean;
    recordsTotal: number;
    resultsCount: number;
    pagesCount: number;
  };
};

export interface IProductRoutingPresenter {
  createStore(): ProductRoutingStore;
  getListProductRouting(store: ProductRoutingStore, data: object): Promise<void>;
  importExcelProductRounting(store: ProductRoutingStore, formData: FormData): Promise<void>;

  getListProductCode(store: ProductRoutingStore, productCode?: string): Promise<void>;
  getListMolds(store: ProductRoutingStore, product?: string, isMold?: boolean): Promise<void>;
}

export function createProductRoutingPresenter({
  productRoutingServices,
}: {
  productRoutingServices: IProductRoutingServices;
}): IProductRoutingPresenter {
  return {
    createStore: (): ProductRoutingStore =>
      observable({
        productRouting: {
          data: [],
          message: '',
          isSuccess: false,
          recordsTotal: 0,
          resultsCount: 0,
          pagesCount: 0,
        },
        importExcelResponse: {
          message: '',
          isSuccess: false,
        },
        listProductCodeResponse: {
          data: [],
          message: '',
          isSuccess: false,
        },
        listMold: {
          data: [],
          message: '',
          isSuccess: false,
          recordsTotal: 0,
          resultsCount: 0,
          pagesCount: 0,
        },
      }),
    getListProductRouting: async (store, data) => {
      try {
        const result = await productRoutingServices.getListProductRouting(data);
        runInAction(() => {
          store.productRouting.data = result.data;
          store.productRouting.isSuccess = result.isSuccess;
          store.productRouting.message = result.message;
          store.productRouting.pagesCount = result.pagesCount;
          store.productRouting.recordsTotal = result.recordsTotal;
          store.productRouting.resultsCount = result.resultsCount;
        });
      } catch (error) {
        console.log(error);
      }
    },
    importExcelProductRounting: async (store, formData) => {
      try {
        const result = await productRoutingServices.importExcelProductRouting(formData);
        runInAction(() => {
          store.importExcelResponse.isSuccess = result.isSuccess;
          store.importExcelResponse.message = result.message;
        });
      } catch (error) {
        console.log(error);
      }
    },
    getListProductCode: async (store, productCode) => {
      try {
        const result = await productRoutingServices.getListProductCode(productCode);
        runInAction(() => {
          store.listProductCodeResponse.data = result.data;
          store.listProductCodeResponse.isSuccess = result.isSuccess;
          store.listProductCodeResponse.message = result.message;
        });
      } catch (error) {
        console.log(error);
      }
    },
    getListMolds: async (store, product, isMold) => {
      try {
        const result = await productRoutingServices.getListMolds(product, isMold);
        runInAction(() => {
          store.listMold.data = result.data;
          store.listMold.isSuccess = result.isSuccess;
          store.listMold.message = result.message;
        });
      } catch (error) {
        console.log(error);
      }
    },
  };
}
